import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
export function TermsPage() {
  return <div className="min-h-screen w-full bg-white" data-id="element-2716">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100" data-id="element-2717">
        <div className="w-full px-6 md:px-12 lg:px-24" data-id="element-2718">
          <div className="max-w-7xl mx-auto h-20 flex items-center" data-id="element-2719">
            <Link to="/" data-id="element-2720">
              <img src="https://cdn.magicpatterns.com/uploads/9qJGNjQNSV94689CCZT1kr/newTM_black_copy.png" alt="Synthia" className="h-8" data-id="element-2721" />
            </Link>
            <Navigation data-id="element-2722" />
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="pt-32 pb-24 px-6 md:px-12 lg:px-24" data-id="element-2723">
        <div className="max-w-4xl mx-auto" data-id="element-2724">
          <h1 className="text-5xl md:text-6xl font-bold mb-16 font-['Syne'] text-black" data-id="element-2725">
            TERMS OF SERVICES
          </h1>

          <div className="space-y-12 font-['Lora'] text-gray-800 leading-relaxed" data-id="element-2726">
            <section data-id="element-2727">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2728">
                1. Overview
              </h2>
              <p className="text-lg mb-4" data-id="element-2729">
                Welcome to MeetSynthia.ai ("Synthia," "we," "us," or "our").
                These Terms and Conditions ("Terms") govern your access to and
                use of our website, products, and services (collectively, the
                "Platform").
              </p>
              <p className="text-lg" data-id="element-2730">
                By accessing or using the Platform, you agree to be bound by
                these Terms and our Privacy Policy. If you do not agree,
                discontinue use immediately.
              </p>
            </section>

            <section data-id="element-2731">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2732">
                2. Nature of the Service
              </h2>
              <p className="text-lg mb-4" data-id="element-2733">
                MeetSynthia.ai provides an AI-driven instruction layer that
                augments, governs, and optimizes user and agentic inputs ("prompts") for
                compatibility with large language models ("LLMs").
              </p>
              <p className="text-lg mb-4" data-id="element-2734">
                Synthia operates exclusively at the instruction layer. We do not
                generate, produce, or provide final AI outputs. All generative
                content, answers, and responses are produced entirely by
                external frontier AI models (e.g., OpenAI, Anthropic, Google, or
                your chosen enterprise LLM).
              </p>
              <p className="text-lg" data-id="element-2735">
                Synthia's role is limited to preparing, governing, structuring,
                and verifying prompt instructions using configurable
                "guardrails," "attributes," "roles," and "workflows."
              </p>
            </section>

            <section data-id="element-2736">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2737">
                3. No Responsibility for AI Output
              </h2>
              <p className="text-lg mb-4" data-id="element-2738">
                Because Synthia operates solely at the instruction layer and
                does not produce final answers, you explicitly acknowledge and
                agree that:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2739">
                <li data-id="element-2740">
                  Synthia is not responsible for any content, answers, or
                  outputs generated by third-party AI systems.
                </li>
                <li data-id="element-2741">
                  Synthia makes no warranties, representations, or guarantees as
                  to the accuracy, completeness, legality, reliability, safety,
                  or appropriateness of AI-generated outputs.
                </li>
                <li data-id="element-2742">
                  Synthia cannot and does not make claims regarding security,
                  PII handling, bias mitigation, or factual accuracy of final
                  outputs—these are determined entirely by the frontier LLM
                  provider.
                </li>
                <li data-id="element-2743">
                  You agree to independently review, verify, and validate all
                  AI-generated results before use, publication, or reliance.
                </li>
                <li data-id="element-2744">
                  Any issues related to output quality, hallucinations, bias,
                  toxicity, or compliance violations are the sole responsibility
                  of the AI model provider and the user.
                </li>
              </ul>
            </section>

            <section data-id="element-2745">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2746">
                4. Enterprise Hosting and Data Handling
              </h2>
              <p className="text-lg mb-4" data-id="element-2747">
                When deployed in an enterprise environment, Synthia may be
                hosted:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2748">
                <li data-id="element-2749">
                  Privately within the client's infrastructure (self-hosted,
                  on-premises, or VPC), or
                </li>
                <li data-id="element-2750">In Synthia's secure managed cloud environment.</li>
              </ul>

              <p className="text-lg mt-4 mb-2" data-id="element-2751">In both cases:</p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2752">
                <li data-id="element-2753">
                  The enterprise retains full ownership of its data, prompts,
                  guardrails, workflows, and all proprietary configurations.
                </li>
                <li data-id="element-2754">
                  Synthia processes data solely for the purpose of providing,
                  improving, and supporting the Platform.
                </li>
                <li data-id="element-2755">
                  Synthia will never sell, monetize, or use client data for
                  model training, marketing, or competitive purposes.
                </li>
                <li data-id="element-2756">
                  Client-specific proprietary information, including custom
                  guardrails, unique workflows, domain expertise, and
                  institutional knowledge extracted from your organization, will
                  never be shared with third parties or other customers.
                </li>
              </ul>

              <p className="text-lg mt-4 mb-2" data-id="element-2757">
                Data sharing with third parties occurs only:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2758">
                <li data-id="element-2759">With the client's explicit written consent, or</li>
                <li data-id="element-2760">As required by law, court order, or lawful subpoena.</li>
              </ul>
            </section>

            <section data-id="element-2761">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2762">
                5. Marketplace and Contextual Intelligence Catalog
              </h2>
              <p className="text-lg mb-4" data-id="element-2763">
                Synthia operates a marketplace of contextual intelligence that
                includes:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2764">
                <li data-id="element-2765">
                  Pre-built guardrails, roles, attributes, and workflows
                  developed by Synthia.
                </li>
                <li data-id="element-2766">Community-contributed and third-party components.</li>
                <li data-id="element-2767">Industry best practices and common governance patterns.</li>
              </ul>

              <p className="text-lg mt-4 mb-2" data-id="element-2768">
                You acknowledge and agree that:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2769">
                <li data-id="element-2770">
                  Best practices, industry standards, and common governance
                  patterns naturally overlap across organizations and cannot be
                  considered proprietary to any single client.
                </li>
                <li data-id="element-2771">
                  While your proprietary and confidential information will never
                  be shared, Synthia may develop similar or related guardrails,
                  workflows, or governance patterns for other clients based on
                  industry knowledge, public information, and independent
                  development.
                </li>
                <li data-id="element-2772">
                  No client has exclusive rights to general concepts,
                  approaches, or methodologies in AI governance.
                </li>
                <li data-id="element-2773">
                  The marketplace may contain components similar to those
                  developed for your organization, reflecting common industry
                  needs rather than disclosure of your proprietary information.
                </li>
                <li data-id="element-2774">
                  You cannot claim ownership or exclusive rights over
                  industry-standard practices, common use cases, or generally
                  applicable governance frameworks.
                </li>
                <li data-id="element-2775">
                  Synthia commits that any components in the marketplace derived
                  from work with specific clients will be sufficiently
                  abstracted and generalized to remove client-specific
                  proprietary information, trade secrets, and confidential
                  business logic.
                </li>
              </ul>
            </section>

            <section data-id="element-2776">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2777">
                6. License and Acceptable Use
              </h2>
              <p className="text-lg mb-4" data-id="element-2778">
                You are granted a limited, revocable, non-exclusive license to
                use the Platform for internal business purposes. You may not:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2779">
                <li data-id="element-2780">
                  Use the Platform for unlawful, infringing, or harmful
                  activity.
                </li>
                <li data-id="element-2781">
                  Reverse engineer, decompile, or modify any part of the
                  Platform.
                </li>
                <li data-id="element-2782">
                  Attempt to access another customer's data, configurations, or
                  restricted systems.
                </li>
                <li data-id="element-2783">
                  Use the Platform to generate content that violates applicable
                  laws or third-party rights.
                </li>
              </ul>
              <p className="text-lg mt-4" data-id="element-2784">
                We reserve the right to suspend or terminate access for
                violations of these Terms.
              </p>
            </section>

            <section data-id="element-2785">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2786">
                7. Intellectual Property
              </h2>
              <p className="text-lg mb-4" data-id="element-2787">
                All intellectual property in the Platform, including software,
                base guardrail logic, BrandKey™ technology, visual interfaces,
                documentation, and core architecture, belongs to MeetSynthia,
                Inc. or its licensors.
              </p>
              <p className="text-lg mb-2" data-id="element-2788">Users retain ownership of:</p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2789">
                <li data-id="element-2790">Their original data and prompts.</li>
                <li data-id="element-2791">Custom guardrails and configurations they create.</li>
                <li data-id="element-2792">Proprietary workflows and institutional knowledge.</li>
              </ul>
              <p className="text-lg mt-4" data-id="element-2793">
                By using the Platform, you grant Synthia a limited,
                non-exclusive right to process, host, and analyze your
                configurations solely to provide and improve the service. This
                license terminates upon account closure, subject to retention
                periods specified in our Privacy Policy.
              </p>
            </section>

            <section data-id="element-2794">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2795">
                8. Third-Party Integrations
              </h2>
              <p className="text-lg mb-4" data-id="element-2796">
                Synthia integrates with external AI providers and enterprise
                systems at your direction. You acknowledge that:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2797">
                <li data-id="element-2798">
                  We are not responsible for third-party systems, their
                  availability, performance, uptime, or outputs.
                </li>
                <li data-id="element-2799">
                  You must comply with all applicable third-party terms of
                  service (e.g., OpenAI API Terms, Anthropic Terms, Google Cloud
                  Terms).
                </li>
                <li data-id="element-2800">
                  Any issues with AI model performance, availability, or outputs
                  must be addressed with the respective provider.
                </li>
              </ul>
            </section>

            <section data-id="element-2801">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2802">
                9. Disclaimers
              </h2>
              <p className="text-lg mb-4 uppercase font-bold" data-id="element-2803">
                THE PLATFORM IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT
                WARRANTY OF ANY KIND.
              </p>
              <p className="text-lg mb-4 uppercase font-bold" data-id="element-2804">
                WE EXPRESSLY DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED,
                INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY,
                FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, ACCURACY,
                RELIABILITY, OR SECURITY.
              </p>
              <p className="text-lg mb-4 uppercase font-bold" data-id="element-2805">
                NO ADVICE OR INFORMATION OBTAINED FROM SYNTHIA SHALL CREATE ANY
                WARRANTY NOT EXPRESSLY STATED IN THESE TERMS.
              </p>
              <p className="text-lg uppercase font-bold" data-id="element-2806">
                ALL AI OUTPUTS MUST BE REVIEWED BY QUALIFIED HUMANS BEFORE USE.
                AUTOMATED RELIANCE ON AI OUTPUTS IS DONE AT YOUR SOLE RISK.
              </p>
            </section>

            <section data-id="element-2807">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2808">
                10. Limitation of Liability
              </h2>
              <p className="text-lg mb-4 uppercase font-bold" data-id="element-2809">
                TO THE MAXIMUM EXTENT PERMITTED BY LAW:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2810">
                <li data-id="element-2811">
                  MeetSynthia shall not be liable for any indirect, incidental,
                  consequential, special, exemplary, or punitive damages,
                  including but not limited to loss of profits, data, use,
                  goodwill, or other intangible losses.
                </li>
                <li data-id="element-2812">
                  Our total aggregate liability for any claim shall not exceed
                  the total amount paid to MeetSynthia in the six (6) months
                  immediately preceding the claim, or $100 USD, whichever is
                  greater.
                </li>
                <li data-id="element-2813">
                  This limitation applies regardless of the theory of liability
                  (contract, tort, negligence, strict liability, or otherwise)
                  and even if we have been advised of the possibility of such
                  damages.
                </li>
              </ul>
              <p className="text-lg mt-4" data-id="element-2814">
                Given that Synthia operates solely at the instruction layer and
                all outputs are produced by third-party AI systems, MeetSynthia
                cannot be held responsible for any damages resulting from
                AI-generated content, including but not limited to
                misinformation, bias, harmful content, privacy violations,
                regulatory non-compliance, or financial losses.
              </p>
            </section>

            <section data-id="element-2815">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2816">
                11. Indemnification
              </h2>
              <p className="text-lg mb-4" data-id="element-2817">
                You agree to indemnify, defend, and hold harmless MeetSynthia,
                its affiliates, officers, directors, employees, agents, and
                licensors from and against any and all claims, liabilities,
                damages, losses, costs, expenses, or fees (including reasonable
                attorneys' fees) arising from:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2818">
                <li data-id="element-2819">Your use or misuse of the Platform.</li>
                <li data-id="element-2820">Your violation of these Terms.</li>
                <li data-id="element-2821">Your violation of any rights of another party.</li>
                <li data-id="element-2822">
                  Content generated by third-party AI systems that you deploy,
                  publish, or rely upon.
                </li>
                <li data-id="element-2823">
                  Any breach of your representations or warranties herein.
                </li>
              </ul>
            </section>

            <section data-id="element-2824">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2825">
                12. Compliance with Data Protection Laws
              </h2>
              <p className="text-lg mb-4" data-id="element-2826">
                Each party shall comply with all applicable data protection
                laws, including but not limited to the General Data Protection
                Regulation (GDPR), California Consumer Privacy Act (CCPA),
                Health Insurance Portability and Accountability Act (HIPAA)
                where applicable, and other relevant frameworks.
              </p>
              <p className="text-lg" data-id="element-2827">
                When Synthia acts as a data processor, we process data only
                under the written instructions of the data controller (the
                client). Clients are responsible for ensuring their use of the
                Platform complies with all applicable regulations.
              </p>
            </section>

            <section data-id="element-2828">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2829">
                13. Termination
              </h2>
              <p className="text-lg mb-4" data-id="element-2830">
                MeetSynthia may suspend or terminate your access at any time
                for:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2831">
                <li data-id="element-2832">Violation of these Terms.</li>
                <li data-id="element-2833">Non-payment of fees.</li>
                <li data-id="element-2834">Engagement in fraudulent, harmful, or illegal activity.</li>
                <li data-id="element-2835">Court order or legal requirement.</li>
              </ul>
              <p className="text-lg mt-4" data-id="element-2836">
                Upon termination, you must immediately cease all use of the
                Platform. Data retention and deletion procedures are governed by
                our Privacy Policy and any applicable Data Processing Agreement.
              </p>
            </section>

            <section data-id="element-2837">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2838">
                14. Governing Law and Dispute Resolution
              </h2>
              <p className="text-lg mb-4" data-id="element-2839">
                These Terms are governed by and construed in accordance with the
                laws of the State of Delaware, United States, without regard to
                its conflict of law provisions.
              </p>
              <p className="text-lg" data-id="element-2840">
                Any disputes arising from or relating to these Terms or the
                Platform shall be resolved exclusively in the state or federal
                courts located in Delaware. You consent to the personal
                jurisdiction of such courts.
              </p>
            </section>

            <section data-id="element-2841">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2842">
                15. Changes to Terms
              </h2>
              <p className="text-lg mb-4" data-id="element-2843">
                We reserve the right to modify these Terms at any time. Changes
                will be effective upon posting to the website with a new "Last
                Updated" date. Your continued use of the Platform after changes
                are posted constitutes acceptance of the revised Terms.
              </p>
            </section>

            <section data-id="element-2844">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2845">
                16. Severability
              </h2>
              <p className="text-lg" data-id="element-2846">
                If any provision of these Terms is found to be unenforceable or
                invalid, that provision shall be limited or eliminated to the
                minimum extent necessary, and the remaining provisions shall
                remain in full force and effect.
              </p>
            </section>

            <section data-id="element-2847">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2848">
                17. Entire Agreement
              </h2>
              <p className="text-lg" data-id="element-2849">
                These Terms, together with our Privacy Policy and any applicable
                Data Processing Agreement, constitute the entire agreement
                between you and MeetSynthia regarding the Platform and supersede
                all prior or contemporaneous understandings and agreements.
              </p>
            </section>

            <section data-id="element-2850">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2851">
                18. Contact
              </h2>
              <p className="text-lg mb-4" data-id="element-2852">For questions about these Terms:</p>
              <p className="text-lg" data-id="element-2853">📧 legal@meetsynthia.ai</p>
              <p className="text-lg mt-4" data-id="element-2854">
                MeetSynthia, Inc.
                <br data-id="element-2855" />
                Wilmington, Delaware, USA
              </p>
              <p className="text-lg mt-6" data-id="element-2856">Last Updated: December 26, 2024</p>
            </section>
          </div>
        </div>
      </main>

      <Footer data-id="element-2857" />
    </div>;
}